import React from 'react';

import SearchSort from '../../search-filter/components/search-sort';
import { RadioGroup, RadioOption } from '../../shared/components/radio';
import { withError } from '../../shared/components/error-boundary';

export const MobileSortComponent = ({ sort, index, isSelected}) => {
    return (
        <RadioOption value={index}>
            {sort.label}
        </RadioOption>);
    
}

class VWAMobileSort extends React.PureComponent {

    handleChange = (setSort) => {
        let { closeModal, options } = this.props;
        return (value) => {
            const { field, order } = options[value];
            closeModal();
            setSort({ field, order });
        }
    }

    render(){
        const { options } = this.props;
        return (
            <SearchSort options={options} className={"vwa-mobile-sort"}>
                {
                    ({options, value, setSort}) => {
                        return (
                            <RadioGroup 
                             onChange={this.handleChange(setSort)}
                             defaultValue={value}>
                            {     
                                options.map((sort, index) => {
                                    return (
                                        <RadioOption 
                                            key={sort.label}
                                            value={index}
                                            data-metrics-event='e_facet' 
                                            data-metrics-event-name='sortBy'
                                            data-metrics-sort-type={sort.label && sort.label.toLowerCase().replace(/\s/ig,'-')}
                                        >
                                        {sort.label}
                                        </RadioOption>);
                                    })
                            }
                            </RadioGroup>);
                    }
                }
            </SearchSort>
        );
    }
}

export default withError(VWAMobileSort);
